export const Data = [
    { 
      question: 'What is a MIRA Community ?',
      answer: 'MIRA is not just a PNG collection, but an icon of a community, a strong and solid community in an extraordinary way.'
    },
    { 
      question: 'What is MIRA Collection ?',
      answer: 'This is a simple art collection that takes its power from the ardent team behind it and the solid community surround it.'
    },
    { 
      question: 'what is Mira aiming ?',
      answer: 'MIRA is aiming to be the first destination for any collection that wants to advertise for their community in the NFT space.'
    }
  ];





//   const questions = [
//     {
//         id: 1,
//         title: 'Who can open a Draft account?',
//         description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Magni voluptate unde vero corporis tempora praesentium laboriosam ratione incidunt a odit.' 
//     },
//     {
//         id: 2,
//         title: 'What if I withdraw money abroad?',
//         description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Magni voluptate unde vero corporis tempora praesentium laboriosam ratione incidunt a odit.' 
//     },
//     {
//         id: 3,
//         title: 'What happens when my subscription ends?',
//         description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Magni voluptate unde vero corporis tempora praesentium laboriosam ratione incidunt a odit.' 
//     },
    // {
    //     id: 4,
    //     title: 'Is this service better than YouBay?',
    //     description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Magni voluptate unde vero corporis tempora praesentium laboriosam ratione incidunt a odit.' 
    // },
    // {
    //     id: 5,
    //     title: 'What happens if I withdraw more than $250?',
    //     description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Magni voluptate unde vero corporis tempora praesentium laboriosam ratione incidunt a odit.' 
    // }
// ]

// export default questions;